import React from 'react';
import { Card } from 'react-bootstrap-5';

export default function AggregateView() {
  return (
    <Card className="dashed-border m-0 text-center" name="aggregate-state">
      <Card.Body>
        <h4 className="text-muted mb-4">
          Imports are unavailable while viewing All Databases
        </h4>
        <a
          className="btn btn-accent js-bootbox-link js-databases-modal-link"
          data-class="databases-modal js-databases-modal"
          data-inline="true"
          data-title="Switch Database"
          href="/database_settings"
        >
          Switch Database
        </a>        
      </Card.Body>
    </Card>
  );
}
